<template>
  <div class="flex-col page space-y-21" v-if="activity">
    <div class="flex-col">
      <div class="flex-col justify-start items-center group_2">
        <img :src="thumb" style="width: 100%;height: auto;">
      </div>
      <div class="flex-col section">
        <img
                class="image_6"
                src="https://assets.pfotoo.com/election/yaozi.png"
        />
        <div class="flex-col items-start group_7" v-if="task.name">
          <span class="font_2">诚邀您担任</span>
          <div class="group_8">
            <span class="font_2 text_2">#{{task.name}}</span>
            <span class="font_2">评委</span>
          </div>
          <div class="section_2"></div>
        </div>
        <div class="flex-col items-start group_7" v-else="">
          <span class="font_2">诚邀您担任</span>
          <div class="group_8">
            <span class="font_2 text_2">#{{activity.activityName}}</span>
            <span class="font_2">评委</span>
          </div>
          <div class="section_2"></div>
        </div>
        <span class="font_2_2 text_2_2" v-if="task.name">
      活动名称：
      <br />
      {{activity.activityName}}
    </span>
        <div class="flex-row group_9 space-x-20">
          <brand class="image_7" :activity="activity" :task="task"></brand>
        </div>
      </div>
      <wxlite class="hidden-sm-and-up" :activity="activity"
              :diySetting="diySetting" :task="task">
        去评选
      </wxlite>
    </div>
  </div>
</template>

<script>
  import App from '../util/comfun'
  import brand from '../components/brand.vue'
  import wxlite from '../components/wxlite.vue'
  //import 'element-ui/lib/theme-chalk/display.css';
  import "../../static/public.css";
  export default {
    name: 'election',
    data () {
      return {
        thumb:'',
        activity:null,
        task:{id:this.$route.params.taskid||''},
        diySetting:{
          buttonName:'去评选',
          className:'wxlite',
        },
      }
    },
    components:{
      brand,
      wxlite,
    },
    methods:{
      async getDetail(){
        if(this.task.id) {
          let taskInfo=(await App.demand('chooseTask/info/{taskId}','GET',{taskId:this.task.id})).data
          if(taskInfo){
            this.task=taskInfo
          }
        }
        App.Contribution.GetContributionById({id:this.id}).then(res=>{
          if(res.code!=200) return this.$message({
            type:'error',
            message:'咦...链接不正确或网络不稳定，请检查后重试!',
            duration:-1,
          })
          res.data.description=(res.data.description||'').replace(/<[^>]+>/g,'')
          if(res.data.activityCovers[0].materialType== "VideoMaterialType"){
            this.thumb=res.data.activityCovers[0].url+'?vframe/jpg/offset/1'
          }else{
            this.thumb=res.data.activityCovers[0].url+'?imageMogr2/thumbnail/750x/quality/100!/ignore-error/1/crop/750x520';
          }
          this.activity=res.data
          this.activity.thumb=this.thumb
        })
      },
    },
    mounted(){
      console.log(this.$route.params.id)
      this.id=this.$route.params.id;
      this.getDetail()
    },

  }
</script>

<style scoped>
  .page {
    padding-bottom: 21px;
    background-color: #ffffff;
    width: 375px;
    overflow-y: auto;
    overflow-x: hidden;
    height: 100%;
    margin: 0 auto;
  }
  .space-y-21 > *:not(:first-child) {
    margin-top: 21px;
  }
  .group_2 {
    position: relative;
  }
  .image {
    width: 375px;
    height: 310px;
  }
  .group_3 {
    padding-left: 6px;
    padding-bottom: 80px;
    position: absolute;
    left: 0;
    right: 5px;
    top: 3px;
  }
  .space-y-10 > *:not(:first-child) {
    margin-top: 10px;
  }
  .group_4 {
    padding-top: 1px;
    position: relative;
  }
  .group_5 {
    position: absolute;
    left: 0;
    top: 50%;
    transform: translateY(-50%);
  }
  .image_2 {
    margin: 2px 0 4px;
    flex-shrink: 0;
    width: 17px;
    height: 10px;
  }
  .text {
    margin-left: 4px;
    color: #ffffff;
    font-size: 12px;
    font-family: '.AppleSystemUIFont';
    line-height: 15px;
  }
  .image_3 {
    margin: 2px 0 4px 5px;
    flex-shrink: 0;
    width: 15px;
    height: 10px;
  }
  .font_1 {
    font-size: 12px;
    font-family: 'PingFangSC-Regular';
    line-height: 17px;
    color: #ffffff;
  }
  .group_6 {
    position: absolute;
    right: 0.5px;
    top: 50%;
    transform: translateY(-50%);
  }
  .image_4 {
    margin: 2px 0 4px 2px;
    flex-shrink: 0;
    width: 27px;
    height: 11.5px;
  }
  .image_5 {
    align-self: flex-end;
    border-radius: 11.5px;
    width: 64px;
    height: 23px;
  }
  .section {
    margin: -37px 19px 0;
    padding: 28px 19px 0;
    border-radius: 5px;
    background-image: url('https://assets.pfotoo.com/election/h5-bg.png');
    background-size: 100% 100%;
    background-repeat: no-repeat;
    position: relative;
  }
  .image_6 {
    align-self: flex-start;
    width: 50px;
    height: 50px;
    background-color: #fefefe;
  }
  .group_7 {
    margin-top: 40px;
  }
  .font_2 {
    font-size: 18px;
    font-family: 'PingFangSC-Medium';
    line-height: 25px;
    font-weight: 500;
    color: #ac8f76;
  }
  .group_8 {
    margin-top: 15px;
  }
  .text_2 {
    color: #5d5d5d;
  }
  .section_2 {
    margin-top: 20px;
    background-color: #deb383;
    width: 45px;
    height: 5px;
  }
  .group_9 {
    margin-top: 28px;
    padding: 31px 0 41px;
    border-top: solid 1px #f5f5f5;
  }
  .space-x-20 > *:not(:first-child) {
    margin-left: 20px;
  }
  .image_7 {
    width: 100px;
    height: 100px;
  }
  .group_10 {
    margin-top: 24px;
  }
  .space-y-5 > *:not(:first-child) {
    margin-top: 5px;
  }
  .text_3 {
    color: #5d5d5d;
    font-size: 14px;
    font-family: 'PingFang-SC-Medium';
    font-weight: 500;
    line-height: 20px;
  }
  .text_4 {
    color: #999999;
  }
  .text-wrapper {
    padding: 8px 0 7px;
    align-self: center;
    background-color: #3dc4a7;
    border-radius: 17.5px;
    width: 290px;
  }
  .text_5 {
    color: #faf6f6;
    font-size: 14px;
    font-family: 'PingFangSC-Regular';
    line-height: 20px;
  }

  .font_2_2 {
    font-size: 12px;
    font-family: 'PingFangSC-Regular';
    color: #999999;
  }
  .text_2_2 {
    margin-top: 20px;
    line-height: 21px;
    text-align: left;
  }
</style>



// WEBPACK FOOTER //
// src/pages/election.vue